import { useCallback, useEffect } from "react";
import { debounce } from "lodash";
import { submitAbandonedGiftTrackingData } from "../../api";

/**
 * @description Custom hook for sending tracking data
 * @param {object} props
 * @param {object} props.abandonedGiftTrackingData
 * @param {number} props.formId
 * @param {boolean} props.shouldSendTrackingData
 * @returns {null}
 */
const useTrackAbandonedGift = ({
    abandonedGiftTrackingData,
    formId,
    shouldSendTrackingData,
}) => {
    const handleSubmitAbandonedGiftTrackingData = (
        _abandonedGiftTrackingData,
        _formId,
    ) => {
        submitAbandonedGiftTrackingData({
            formId: _formId,
            abandonedGiftTrackingData: _abandonedGiftTrackingData,
        });
        // if we want to do something in the then/catch blocks
        // we would do that here
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceSubmitAbandonedGiftTrackingData = useCallback(
        debounce(handleSubmitAbandonedGiftTrackingData, 500),
        [],
    );

    useEffect(() => {
        // let apiMounted = true;
        if (shouldSendTrackingData) {
            debounceSubmitAbandonedGiftTrackingData(
                abandonedGiftTrackingData,
                formId,
            );
        }
        // -------------------------------------------------------------------------
        // NOTE: Since we aren't doing anything with the response, we currently do not
        // have to worry about clean up of async actions for this api call. If that changes,
        // we need to pass `apiMounted` to the handleSubmitAbandonedGiftTrackingData function
        // and wrap then/catch actions in an eval based on `apiMounted` value
        // -------------------------------------------------------------------------
        // return () => {
        //     apiMounted = false;
        // };
    }, [
        abandonedGiftTrackingData,
        debounceSubmitAbandonedGiftTrackingData,
        formId,
        shouldSendTrackingData,
    ]);
    return null;
};

export default useTrackAbandonedGift;
